import Swiper from "swiper/bundle";

export default function Promotion (){
    let promotionContainer = document.querySelector('[data-promotion="container"]');

    if (promotionContainer){
        let promotionSwiper = document.querySelector('[data-promotion="swiper"]');
        let promotionLinkBtn = document.querySelector('[data-promotion="link-btn"]');

        new Swiper(promotionSwiper, {
            modules: [],
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                clickable: true,
                el: ".promotion__pagination",
            },
            on:{
                slideChange: function (swiper){
                    let currentSlide = swiper.slides[swiper.activeIndex];
                    promotionLinkBtn.setAttribute('href', currentSlide.dataset.link)
                }
            }
        });
    }
}